import { useState, useEffect, useMemo } from "react"
import { Box, Card, Grid, TextField, Typography, IconButton, useTheme, Chip } from "@mui/material"
import { MapBase, MarkerFibraNaps, MarkerFibraCliente } from "../../components"
import KmzService from "../../services/kmz.service"
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import PlaceIcon from '@mui/icons-material/Place';
import AuxiliarFunction from "../../function/AuxiliarFunction"

const MapaFibraOpticaScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [coordenadas, setCoordenadas] = useState({texto:'',lat: null,lng: false})
    const [isLoadingPrefa, setIsLoadingPrefa] = useState(false);
    const [rangoRadio, setRangoRadio] = useState(80);
    const [prefactibilidadLocation, setPrefactibilidadLocation] = useState({
        lat: -24.789251,
        lng: -65.410393
    });
    const [mapLocation, setMapLocation] = useState({
        lat: -24.789251,
        lng: -65.410393
    });
    const [prefactibilidad, setPrefactibilidad] = useState(null);
    const onPrefa = async(newCoord) =>{
        setCoordenadas({texto:`${newCoord.lat}, ${newCoord.lng}`,lat: newCoord.lat, lng:newCoord.lng})
        setIsLoadingPrefa(true)
        await KmzService.coberturaFO({lat: newCoord.lat, lng:newCoord.lng}).then((r)=>{
            setPrefactibilidad(r);
            if(r?.rango){
                setRangoRadio(r?.rango)
            }
            setIsLoadingPrefa(false)
        }).catch((err)=>{
            setIsLoadingPrefa(false)
        })
    }

    const onClickMap = async(newCoord,moverCamara) => {
        if(moverCamara){
            setMapLocation(newCoord)
        }
        await onPrefa(newCoord)
        setPrefactibilidadLocation(newCoord);
    }

    const styleInputHeight = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#8899a6' : 'gray',
            fontSize: 15
        },
        '& fieldset': {
            borderRadius: 2,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            height: 45,
            backgroundColor: isDarkMode ? 'rgba(255,255,255,0.03)' : 'transparent',
        },
        '& label':{
            marginTop: -0.5,
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                height: 45,
                borderColor: isDarkMode ? '#90caf9' : '#0364ff'
            },
            '&:hover':{
                border: 1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#5a6a7e' : 'gray',
                height: 40
            },
            '&.Mui-focused': {
                '&:hover':{
                border:0,
                height: 40
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 40
        }
    }), [isDarkMode]);

    const onSubmitCoordenadas = () =>{
        setIsLoadingPrefa(true)
        const quitarEspacios = coordenadas.texto.replace(/ /g, "")
        const separador = quitarEspacios.split(',')
        if(separador.length === 2){
            const validCoord = `${separador[0]}, ${separador[1]}`
            const valid = AuxiliarFunction.isValidCoordinates(validCoord)
            if(valid){
                setIsLoadingPrefa(false)
                onClickMap({lat:Number(separador[0]), lng:Number(separador[1])},true)
                setCoordenadas({texto: coordenadas.texto, estadoErr: false,lat: separador[0], lng:separador[1]})
            }else{
                setIsLoadingPrefa(false)
                setCoordenadas({texto: coordenadas.texto, estadoErr: true,lat: coordenadas.lat, lng:coordenadas.lng})
            }
        }else{
            setIsLoadingPrefa(false)
            setCoordenadas({texto: coordenadas.texto, estadoErr: true,lat: coordenadas.lat, lng:coordenadas.lng})
        }
    }
    useEffect(() => {
        document.title = `Cobertura FO`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto',backgroundColor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={{xs:1.5, sm:2, md:3}} display='flex' justifyContent='center' spacing={1}>
                <Grid item xs={12} md={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold', fontSize:{xs:'1.3rem', sm:'1.6rem', md:'2rem'}}} variant="h2">Mapa fibra optica</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important',p:2,borderRadius: 5, border: isDarkMode ? '1px solid #3d4a62' : 'none', boxShadow: isDarkMode ? 0 : 3}}>
                        <TextField
                            fullWidth
                            autoComplete='off'
                            sx={styleInputHeight}
                            InputLabelProps={{shrink: true}}
                            value={coordenadas?.texto}
                            onChange={(e)=>setCoordenadas({texto: e.target.value, estadoErr: false,lat: coordenadas.lat, lng:coordenadas.lng})}
                            InputProps={{
                                endAdornment: (
                                <IconButton onClick={()=>onSubmitCoordenadas()}>
                                    <GpsFixedIcon sx={{color: isDarkMode ? '#90caf9' : '#000'}} size={35} />
                                </IconButton>
                                ),
                            }}
                        />
                        {coordenadas?.estadoErr && (
                            <Typography sx={{color: isDarkMode ? '#f87171' : 'red',fontSize:10,marginLeft:2}}>No son unas coordenadas validas</Typography>
                        )}
                    </Card>
                </Grid>
                <Grid item xs={12} md={3} mt={2}>
                    <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important',minHeight:{xs:150, md:250},maxHeight:{xs:400,md:'calc(100vh - 200px)'},overflow:'auto',borderRadius:2, border: isDarkMode ? '1px solid #3d4a62' : 'none', boxShadow: isDarkMode ? 0 : 3,p:1}}>
                        {prefactibilidad?.cobertura && (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',textAlign: 'center',fontWeight: 'bold', fontSize:{xs:'1.1rem',md:'1.4rem'}}} variant="h4">{`${prefactibilidad?.cobertura}`}</Typography>
                                </Grid>
                                <Grid item xs={6} md={12} mb={-1}>
                                    <Typography sx={{color: isDarkMode ? '#b0bec5' : '#000',textAlign: 'center',fontWeight: 'bold', fontSize:{xs:'0.8rem',md:'1rem'}}} variant="h6">{`Radio: ${prefactibilidad?.rango}`}</Typography>
                                </Grid>
                                <Grid item xs={6} md={12}>
                                    <Typography noWrap sx={{color: isDarkMode ? '#b0bec5' : '#000',textAlign: 'center', fontSize:{xs:'0.7rem',md:'1rem'}}} variant="h6">{`${coordenadas.lat},${coordenadas.lng}`}</Typography>
                                </Grid>
                                {Array.isArray(prefactibilidad?.naps) && prefactibilidad?.naps?.length > 0 && (
                                    prefactibilidad?.naps.map((it, idx)=>{
                                        const porcentaje = it?.puertos ? Math.round((it?.usados / it?.puertos) * 100) : 0;
                                        const statusColor = porcentaje >= 100 ? '#e53935' : porcentaje >= 70 ? '#ff9800' : '#43a047';
                                        const distText = `${it?.distancia?.value || it?.distanciaReal || it?.distanciaMts || '-'} mts`;
                                        return (
                                        <Grid item xs={6} sm={4} md={12} key={it?.id_fnap || it?.nombre_fnap}>
                                            <Card 
                                                sx={{
                                                    background: isDarkMode ? '#2d3a52 !important' : '#fff !important', 
                                                    boxShadow: isDarkMode ? '0 2px 8px rgba(0,0,0,0.3)' : '0 1px 4px rgba(0,0,0,0.1)', 
                                                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e8e8e8',
                                                    borderLeft: `3px solid ${statusColor}`,
                                                    borderRadius: '8px',
                                                    p: 0,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    overflow: 'hidden',
                                                    '&:hover': {
                                                        boxShadow: isDarkMode ? '0 4px 16px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.15)',
                                                        transform: 'translateY(-2px)',
                                                        borderLeft: `3px solid ${isDarkMode ? '#90caf9' : '#0364ff'}`,
                                                    }
                                                }}
                                                onClick={() => {
                                                    const napCoords = {
                                                        lat: Number(it?.latitud_fnap),
                                                        lng: Number(it?.longitud_fnap)
                                                    };
                                                    setMapLocation(napCoords);
                                                }}
                                            >
                                                <Box sx={{ p: {xs: 1, md: 1.2} }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.6 }}>
                                                        <PlaceIcon sx={{ fontSize: 14, color: statusColor }} />
                                                        <Typography noWrap sx={{
                                                            color: isDarkMode ? '#e0e0e0' : '#1a1a2e', 
                                                            fontWeight: 700, 
                                                            fontSize: {xs: '0.72rem', md: '0.82rem'},
                                                            flex: 1,
                                                        }}>
                                                            {it?.nombre_fnap}
                                                        </Typography>
                                                        <Typography sx={{
                                                            color: isDarkMode ? '#5a6a7e' : '#bbb',
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                        }}>
                                                            #{idx + 1}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
                                                        <Chip
                                                            size="small"
                                                            label={distText}
                                                            sx={{
                                                                height: 20,
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                backgroundColor: isDarkMode ? 'rgba(25,118,210,0.15)' : 'rgba(25,118,210,0.08)',
                                                                color: isDarkMode ? '#90caf9' : '#1565c0',
                                                                border: `1px solid ${isDarkMode ? 'rgba(144,202,249,0.2)' : 'rgba(21,101,192,0.15)'}`,
                                                                '& .MuiChip-label': { px: 0.8 },
                                                            }}
                                                        />
                                                        <Chip
                                                            size="small"
                                                            label={`${it?.usados}/${it?.puertos}`}
                                                            sx={{
                                                                height: 20,
                                                                fontSize: '0.65rem',
                                                                fontWeight: 700,
                                                                backgroundColor: isDarkMode 
                                                                    ? `${statusColor}22` 
                                                                    : `${statusColor}12`,
                                                                color: statusColor,
                                                                border: `1px solid ${statusColor}33`,
                                                                '& .MuiChip-label': { px: 0.8 },
                                                            }}
                                                        />
                                                        {it?.sector && (
                                                            <Typography noWrap sx={{
                                                                color: isDarkMode ? '#6b7d95' : '#999',
                                                                fontSize: '0.6rem',
                                                                ml: 'auto',
                                                                maxWidth: '45%',
                                                            }}>
                                                                {it?.sector}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                                <Box sx={{
                                                    width: '100%',
                                                    height: 2,
                                                    backgroundColor: isDarkMode ? '#1a2332' : '#f0f0f0',
                                                }}>
                                                    <Box sx={{
                                                        width: `${Math.min(porcentaje, 100)}%`,
                                                        height: '100%',
                                                        backgroundColor: statusColor,
                                                        transition: 'width 0.3s ease',
                                                    }} />
                                                </Box>
                                            </Card>
                                        </Grid>
                                    )})
                                )}
                            </Grid>
                        )}
                    </Card>
                </Grid>
                <Grid item xs={12} md={9} mt={2}>
                    <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important', boxShadow: isDarkMode ? 0 : 3, border: isDarkMode ? '1px solid #3d4a62' : 'none', borderRadius:2,p:1}}>
                        <MapBase
                            mapContainerStyle={{
                                width: '100%',
                                height: 'calc(100vh - 220px)',
                                minHeight: 350,
                            }}
                            onClick={(e)=>onClickMap(e,true)}
                            isSearchable={false}
                            options={{
                                maxZoom: 23,
                                minZoom: 8,
                            }}
                            zoom={16}
                            coordinates={mapLocation}
                        >
                            <MarkerFibraCliente
                                item={prefactibilidadLocation}
                                key='onCLickMapFO'
                                rangoBd={rangoRadio}
                            />
                            {(Array.isArray(prefactibilidad?.naps) && prefactibilidad?.naps?.length > 0) && (
                                prefactibilidad?.naps.map((it)=>(
                                    <MarkerFibraNaps
                                        coordenadas={{lat: Number(it?.latitud_fnap),lng: Number(it?.longitud_fnap)}}
                                        key={it?.id_fnap}
                                        item={it}
                                        isInCoverage={it}
                                        origenCoord={prefactibilidadLocation}
                                    />
                                ))
                            )}
                        </MapBase>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default MapaFibraOpticaScreen